import ApiService from '../services/ApiService';
import * as types from './ActionTypes';

import { goToErrorPage, goToNextStep, setInputError } from './GenericActions'; // eslint-disable-line import/no-cycle
import { recordingProbeStarted } from './probes_action';
import { generateCaptcha, invalidCaptcha, notFinishedCaptcha } from './captcha_actions';
import TagService from '../services/TagService';

const creatingIdentities = ({ login, captcha }) => ({
  type: types.CREATE_IDENTITIES,
  payload: {
    login,
    captcha,
  },
});

export const createIdentitiesSuccess = identitiesId => ({
  type: types.CREATE_IDENTITIES_SUCCESS,
  payload: {
    identitiesId,
  },
});

const createIdentitiesFailure = error => ({
  type: types.CREATE_IDENTITIES_FAILURE,
  error,
});

/**
 * Function to create identities object
 * Return login or captcha errors when exists
 * @param login
 * @param captcha
 * @param nextStep bool said if success result continue to next step, use it if gotonextstep is done in another place
 * @return {function(*): Promise<T>}
 */
export const createIdentities = ({ login, captcha, nextStep = true }) => (dispatch) => {
  dispatch(recordingProbeStarted());
  dispatch(creatingIdentities({ login, captcha }));
  return ApiService.createIdentities({
    login,
    captcha,
  }).then(
    (res) => {
      const { step, data } = res.data;
      dispatch(createIdentitiesSuccess(data.resourceId));
      TagService.sendAction('login');
      if (nextStep) {
        dispatch(goToNextStep(step));
      }
    },
    (err) => {
      dispatch(createIdentitiesFailure(err.response));
      if (err.response && err.response.data) {
        const { field, code } = err.response.data;
        switch (field) {
          case 'login':
            switch (code) {
              case 412002:
                dispatch(setInputError({ field: 'login', error: 'empty' })); // No login filled
                break;
              case 412004:
                TagService.sendAction('loginInvalid');
                dispatch(setInputError({ field: 'login', error: 'syntaxInvalid' })); // Login syntax invalid
                break;
              case 412005:
                TagService.sendAction('loginUnknown');
                dispatch(setInputError({ field: 'login', error: 'invalidUser' })); // No existing user
                break;
              default:
                dispatch(goToErrorPage());
            }
            break;
          case 'captcha':
            switch (code) {
              case 412004:
                TagService.sendAction('captchaUnfinished');
                dispatch(notFinishedCaptcha()); // Captcha not finished
                break;
              case 412005:
                TagService.sendAction('captchaInvalid');
                dispatch(invalidCaptcha()); // Captcha invalid and reloading captcha
                dispatch(generateCaptcha());
                break;
              default:
                dispatch(goToErrorPage());
            }
            break;
          default:
            switch (code) {
              case 403101:
              case 403102:
                dispatch(goToErrorPage('rtcForbiddenUnconfirmed')); // NRSU unconfirmed or Internet demat fix, not allowed to use the app
                break;
              default:
                dispatch(goToErrorPage());
            }
            break;
        }
      }
    },
  );
};